import { FC, memo, useCallback } from 'react'

import { useNavigate } from '@tanstack/react-router'
import { AdverseMedia } from 'commons/types/DTO/bank/alerts/adverseMedia'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'

import { columns } from './columns'
import { Filter } from './components'

export const AdverseMediaTable: FC = memo(() => {
  const { data, isTableLoading, onPageChange } = useAlertsContext()
  const navigate = useNavigate()

  const {
    form: { adverseMediaPage, adverseMediaSize },
    showAdverseMedia,
    showAdverseMediaTotalCount
  } = data

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'adverseMedia')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="Adverse Media" anchor="adverse-media">
      <Layer rounded shadowed stretch>
        <Filter />
        <Table<AdverseMedia>
          dataQa={TableDataQa.BP_ALERTS_ADVERSE_MEDIA}
          columns={columns(navigate)}
          dataSource={showAdverseMedia.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('adverseMedia')}
          pagination={{
            page: adverseMediaPage || 1,
            size: adverseMediaSize || 10,
            onChange: handlePageChange,
            total: showAdverseMediaTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
})
